export default {
    actCreated: 'Акт успешно сформирован',
};
